import { jsx as _jsx } from "react/jsx-runtime";
import React, {} from 'react';
import { Button } from "antd";
import { userHasPermission } from "../../../swzutils/UserPermissionsUtil";
import { useAppSelector } from "../../../store";
import { loggedInUserSelector } from "../../../store/slice/auth";
const PermissionButton = ({ permissions, title, children, htmlType = "button", className, target, href, icon, onClick, disabled, loading }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    if (!userHasPermission(loggedInUser, permissions)) {
        return null;
    }
    return (_jsx(Button, { htmlType: htmlType, title: title, className: className, href: href, target: target, onClick: onClick, icon: icon, disabled: disabled, loading: loading, children: children }));
};
export default PermissionButton;
